module.exports = __webpack_public_path__ + "img/jpSuggestion.1d57a2b.png";